import { createContext, useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useProduct } from './ProductContext';
import { useSubscription } from './SubscriptionContext';

import { GA4_KEY, CLOUD_STORAGE_KEYS, ROUTES } from '../utils/constants';
import { sendGTMEvent } from '../utils/analytics';
import { cloudSetItem } from '../utils/cloudStorage';

import OffertPopUp from '../components/OffertPopUp/OffertPopUp';
import Loading from '../components/Loading/Loading';

const UIContext = createContext(null);

export const UIProvider = ({ children }) => {
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(true);
  const [isPopupOpen, setIsPopupOpen] = useState(true);
  const [showOffert, setShowOffert] = useState(false);

  const { setProductId } = useProduct();
  const { setIsHaveSubscriptionHash } = useSubscription();

  const value = {
    isLoading,
    setIsLoading,
    isPopupOpen,
    setIsPopupOpen,
    showOffert,
    setShowOffert,
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const routeURL = window.location.pathname;
    const startAppParam = urlParams.get('tgWebAppStartParam');

    if (startAppParam) {
      const parts = startAppParam.split('_');
      if (parts[0] === 'products' && parts[1]) {
        const id = parts[1];
        setProductId(id);
        navigate(`/products/${id}`);
      }

      if (parts[0] === 'start' && parts[1] === 'subscription') {
        setIsHaveSubscriptionHash(true);
        navigate(ROUTES.subscription);
      }

      if (parts[0] === 'beauty' && parts[1] === 'questions') {
        navigate(ROUTES.beautyQuestions);
      }

      if (parts.length === 1 && parts[0] === 'offert') {
        setShowOffert(true);
      }
    } else if (routeURL) {
      if (routeURL.includes('products/')) {
        const id = routeURL.split('products/')[1];
        setProductId(id);
        navigate(`/products/${id}`);
      }
    }
  }, [navigate, setProductId, setIsHaveSubscriptionHash, setShowOffert]);

  // Show loading or popup if necessary
  if (isLoading) {
    return (
      <Loading
        setIsLoading={setIsLoading}
        setIsPopupOpen={setIsPopupOpen}
        showOffert={showOffert}
        setShowOffert={setShowOffert}
      />
    );
  }

  if (isPopupOpen) {
    return (
      <div className='App'>
        <OffertPopUp
          isOpen={isPopupOpen}
          required
          onClose={async () => {
            setIsPopupOpen(false);
            sendGTMEvent(GA4_KEY.confirm_offert);
            await cloudSetItem(CLOUD_STORAGE_KEYS.is_offer_confirmed, true);
          }}
        />
      </div>
    );
  }

  return <UIContext.Provider value={value}>{children}</UIContext.Provider>;
};

// Custom hook for using this context
export const useUI = () => {
  const context = useContext(UIContext);
  if (!context) {
    throw new Error('useUI must be used within a UIProvider');
  }
  return context;
};
